
// Cada entrada liga uma key do JSON ao nome mostrado na tabela e à unidade
export const INDICATOR_MAP = [
  {  
    title: "Mobility scores",
    titleTooltip: "Indicators and scores related to mobility aspects",    
    indicators: [
      {
        key: "postProjectRetailFloorAreaRatio",
        name: "Retail quality",
        unit: "out of 25",
        subIndicators: [
          {key: "nbShops", name: "Number of shops (shops/km2)"}
        ],
        gridValue: "retailFloorAreaRatioScore",
        maxScore: "25"
      },
      {
        key: "postProjectLandUseMix",
        name: "Land use - mix",
        unit: "out of 25",
        subIndicators: [
          {key: "areaRes", name: "Residential area (m2)"},
          {key: "areaNotRes", name: "Non-residential area (m2)"}
        ],
        gridValue: "landUseMixScore",
        maxScore: "25"
      },
      {
        key: "postProjectStreetConnectivity",
        name: "Intersection density",
        unit: "out of 25",
        subIndicators: [
          {key: "nbIntersections", name: "Number of intersections (intersections/km2)"}
        ],
        gridValue: "streetConnectivityScore",
        maxScore: "25"
      },
      {
        key: "postProjectDwellingResidentialDensity",
        name: "Population density",
        unit: "out of 25",
        subIndicators: [
          {key: "ghsPopSum", name: "Population density (people/km2)"}
        ],
        gridValue: "populationDensityScore",
        maxScore: "25"
      },
    ],
    combined: "postProjectWalkabilityAndCyclabilityCombined",
    lastName: "Mobility Combined Score",
    unit: "out of 100",
    gridValue: "walkabilityCyclabilityCombinedScore",
    maxScore: "25"
  },
   {  
    title: "Liveability scores",
    titleTooltip: "Indicators and scores related to Liveability aspects",    
    indicators: [
      {
        key: "postProjectServices", /*"postProjectRetailFloorAreaRatio",*/  
        name: "Access to amenities",
        unit: "out of 70",
        subIndicators: [
          {key: "scLivHospital3", name: "Accessibility to hospitals (amenities within 15 min walk)"},
          {key: "scLivSchool3", name: "Accessibility to schools (amenities within 15 min walk)"}, 
          {key: "scLivCinetheatre3", name: "Accessibility to cinema (amenities within 15 min walk)"},
          {key: "scLivMuseum3", name: "Accessibility to museums (amenities within 15 min walk)"},
          {key: "scLivGrocery3", name: "Accessibility to groceries (amenities within 15 min walk)"}, 
          {key: "scLivSport3", name: "Accessibility to sports (amenities within 15 min walk)"},
          {key: "scLivChildcare3", name: "Accessibility to childcare (amenities within 15 min walk)"},
          {key: "scLivlibrary3", name: "Accessibility to libraries (amenities within 15 min walk)"}, 
          {key: "scLivPharmacy3", name: "Accessibility to pharmacies (amenities within 15 min walk)"},
        ],
        gridValue: "accessibilityScore",
        maxScore: "70.2" // grid max: 9 amenities x 3 x 2.6
      },
      {
        key: "postProjectEnvironment", /*"postProjectLandUseMix",*/
        name: "Outdoor air quality",
        unit: "out of 10",
        subIndicators: [
          {key: "pm25", name: "PM2.5 concentration (ug/m3)"},
          {key: "no2", name: "NOx concentration (ug/m3)"},
        ],
        gridValue: "exposurePollutantScore",
        maxScore: "10" 
      },
      {
        key: "postProjectNaturalArea", /*"postProjectStreetConnectivity",*/
        name: "Access to green space",
        unit: "out of 10",
        subIndicators: [
          {key: "surfGrSpa", name: "Green spaces accessibility (m2 of green space within 15 min walk)"},
        ],
        gridValue: "naturalAreaScore",
        maxScore: "10" 
      },
      {
        key: "postProjectSafety", /*"postProjectDwellingResidentialDensity",*/
        name: "Urban crime rate",
        unit: "out of 5",
        subIndicators: [
          {key: "criSafety", name: "Crime rate (crimes per 100,000 inhabitants)"},
        ],
        gridValue: null,
        maxScore: "5" // grid features have no crime score, so never disabled
      },
      {
        key: "postProjectTrafficSafety",
        name: "Traffic safety",
        unit: "out of 5",
        subIndicators: [
          {key: "traSafety", name: "Fatal vehicle accidents (per 100,000 inhabitants)"},
        ],
        gridValue: "trafficSafetyScore",
        maxScore: "5"
      },
    ],
    combined: "postProjectLivabilityCombined",
    lastName: "Liveability Combined Score",
    unit: "out of 100",
    gridValue: "livabilityCombinedScore",
    maxScore: "100"
  }
];
